module.exports = __webpack_public_path__ + "static/media/3-3.c43a3760.webp";